export const VerifyTypeBoolean = {
  Verified: true,
  Unverified: false,
};

export const PATIENT_DETAIL_TAB = {
  BASIC_INFO: 1,
  MOUTH_PHOTOS: 2,
  TREATMENT_FEEDBACK: 3,
};
